import React from "react";
import DOMPurify from "dompurify";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';


function  Companies() {
    const companiesList = [
        "Київстар",
        "ПриватБанк",
        "Нова Пошта",
        "Група Метінвест",
        "ДТЕК",
        "Укрексімбанк",
        "YASNO",
        "Uklon",
        "Schneider Electric",
        "ОККО",
        "Cisco Ukraine",
        "Glovo",
        "Raiffeisen Bank",
        "L'Oréal Україна",
        "МакДональдз в Україні",
        "Sigma Software",
        "Фокстрот",
        "BROCARD",
        "Sense Bank",
        "Дарниця",
        "SOCAR",
        "IDS Ukraine",
        "Creatio",
        "ArcelorMittal",
        "UDP Renewables",
        "Астарта-Київ",
        "SoftServe",
        "FRACTAL",
        "Інтерпайп",
        "Nemiroff",
        "ІНГО",
        "Winner",
        "TERWIN",
        "Молочний альянс",
        "NOVUS",
        "NEQSOL HOLDING UKRAINE",
        "Ward Howell Ukraine",
        "Промприлад",
        "Інтергал-Буд",
        "Dragon Capital",
    ];
    const row = [...companiesList, ...companiesList];

    return (
        <section className="mb-[60px] overflow-hidden lg:mb-[120px]">

            <div className="container mx-auto max-w-screen-xl px-5">
                <h2 className="font-bold uppercase text-3xl text-center text-[#000] mb-8
                    sm:text-4xl md:mb-[75px] lg:text-[60px]">
                    Компанії, які відвідали захід
                </h2>
            </div>

            <div className="flex flex-col gap-5 overflow-hidden">

                {/* Ряд 1 */}
                <div className="overflow-hidden">
                    <div className="flex w-max gap-5 lg:gap-8  whitespace-nowrap hover:[animation-play-state:paused] [animation:marquee-left_155s_linear_infinite]">
                        {row.map((item, index) => (
                            <div key={index} className="flex shrink-0 items-center gap-5 lg:gap-8">
                                <span className="text-[28px] md:text-[40px] lg:text-[80px] leading-none font-black uppercase tracking-[-0.03em]">
                                    {item}
                                </span>
                                <div className="w-[10px] h-[10px] lg:w-[20px] lg:h-[20px] bg-[linear-gradient(280deg,#009064_15.38%,#3ac097_61.93%,#ece66a_100%)]"></div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Ряд 2 */}
                <div className="overflow-hidden">
                    <div className="flex w-max gap-5 lg:gap-8 whitespace-nowrap hover:[animation-play-state:paused] [animation:marquee-right_165s_linear_infinite]">
                        {row.map((item, index) => (
                            <div key={index} className="flex shrink-0 items-center gap-5 lg:gap-8">
                                <span className="text-[28px] md:text-[40px] lg:text-[80px] leading-none font-black uppercase tracking-[-0.03em]">
                                    {item}
                                </span>
                                <div className="w-[10px] h-[10px] lg:w-[20px] lg:h-[20px] bg-[linear-gradient(100deg,#009064_15.38%,#3ac097_61.93%,#ece66a_100%)]"></div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Ряд 3 */}
                <div className="overflow-hidden">
                    <div className="flex w-max gap-5 lg:gap-8 whitespace-nowrap hover:[animation-play-state:paused] [animation:marquee-left_155s_linear_infinite]">
                        {row.map((item, index) => (
                            <div key={index} className="flex shrink-0 items-center gap-5 lg:gap-8">
                                <span className="text-[28px] md:text-[40px] lg:text-[80px] leading-none font-black uppercase tracking-[-0.03em]">
                                    {item}
                                </span>
                                <div className="w-[10px] h-[10px] lg:w-[20px] lg:h-[20px] bg-[linear-gradient(280deg,#009064_15.38%,#3ac097_61.93%,#ece66a_100%)]"></div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>

        </section>
    )
}

export default Companies;